@for (category of categories(); track category.id; let isLast = $last) {
  <app-anchor-section [anchor]="category.slug">
    <div class="mb-3 text-2xl">{{ category.name }}</div>

    <p-accordion [multiple]="true">
      @for (
        question of category.questions;
        track question.id;
        let index = $index
      ) {
        <p-accordion-panel [value]="question.id">
          <p-accordion-header>
            <div class="flex gap-1">
              <span>{{ index + 1 }})</span>
              <span>{{ question.name }}</span>
            </div>
          </p-accordion-header>

          <p-accordion-content>
            <app-public-html-content [html]="question.content" />
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </app-anchor-section>

  @if (!isLast) {
    <div class="mb-8"></div>
  }
}
